import React from "react";
import { GridItem, Heading, Text } from "@chakra-ui/react";
import { Grid as ChakraGrid } from "components";
import { Tests, Treatments, Vaccines } from "./components";

const TestsAndVaccines: React.FC = () => (
  <>
    <Heading as="h3" color="black" fontSize="lg" lineHeight="7">
      Tests and vaccinations to be performed today
    </Heading>

    <ChakraGrid
      templateColumns={{
        base: "1fr",
        sm: "repeat(2, 1fr)",
        md: "repeat(3, 1fr)"
      }}
    >
      <GridItem>
        <Text color="gray.600" fontWeight="semibold" my={4}>
          Vaccines:
        </Text>
        <Vaccines />
      </GridItem>
      <GridItem>
        <Text color="gray.600" fontWeight="semibold" my={4}>
          Tests:
        </Text>
        <Tests />
      </GridItem>
      <GridItem>
        <Text color="gray.600" fontWeight="semibold" my={4}>
          Treatments:
        </Text>
        <Treatments />
      </GridItem>
    </ChakraGrid>
  </>
);

export default TestsAndVaccines;
